import React from "react";
import { Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import { addBranchSchema } from "../../../schema/validationSchemas";
import InputField from "../../../components/form/InputField";
import CommonButton from "../../../components/commonButton";
import withModal from "../../../components/withModal";

const BranchModalInner = ({
  isViewMode,
  isEditMode,
  editBranchData,
  onSubmit,
}) => {
  const initialValues = {
    branch_name: editBranchData?.name || "",
    branch_city: editBranchData?.city || "",
  };

  return (<Formik
    initialValues={initialValues}
    validationSchema={addBranchSchema}
    onSubmit={onSubmit}
    enableReinitialize
  >
    {({
      errors,
      touched,
      isSubmitting,
      handleChange,
      handleBlur,
      values,
      handleSubmit,
    }) => (
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <InputField
            label={{ name: "Branch Name" }}
            input={{
              id: "branch_name",
              name: "branch_name",
              type: "text",
              value: values.branch_name,
              placeholder: "Ex. PNB West Branch",
              onChange: handleChange,
              onBlur: handleBlur,
              disabled: isViewMode,
            }}
            validation={{
              isInvalid: touched.branch_name && errors.branch_name,
              message: errors.branch_name,
            }}
          />
          <InputField
            className="mt-4"
            label={{ name: "City" }}
            input={{
              id: "branch_city",
              name: "branch_city",
              type: "text",
              value: values.branch_city,
              placeholder: "Surat",
              onChange: handleChange,
              onBlur: handleBlur,
              disabled: isViewMode,
            }}
            validation={{
              isInvalid: touched.branch_city && errors.branch_city,
              message: errors.branch_city,
            }}
          />
        </Modal.Body>
        {!isViewMode && (
          <Modal.Footer>
            <CommonButton
              title={isEditMode ? "Update Branch" : "Add Branch"}
              type="submit"
              disabled={isSubmitting}
              variant="primary"
            />
          </Modal.Footer>
        )}  </Form>
    )}
  </Formik>
  );
};

const BranchModal = withModal(BranchModalInner);
export default BranchModal;
